<his-plam *ngIf="!readonly">
    <input *ngIf="!readonly" #content [hisDdKey]="i18nIdentifier" type="checkbox"
        [required]="isMandatory()" [(ngModel)]="value" (ngModelChange)="onModelChange($event)">
</his-plam>

<div *ngIf="readonly && value" class="layoutBlock detailPresentationListItem">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{ i18nIdentifier | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{ 'yes' | hisUi }}</span>
    </div>
</div>
